/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import Reflux from 'reflux';
import { Button } from 'antd';
import { hashHistory, withRouter } from 'react-router';
import { DmsTab, TableView, AdvanceFormNew } from '../../components';
import { formatMoney, openNotice } from '../../utils/index.js';
import moment from 'moment';

class SecondCusOrderList extends Reflux.Component {
  constructor (props) {
    super(props);
    
    this.state = {
      opts: ['订单管理'],
      key: 0,
      rows: [],
      total: 1,
      searchObj: {
        code: '',
        customerName: this.channelName,
        startCreatedDate: '',
        endCreatedDate: '',
        areaId: '',
        orderStatus: 0,
        payStatus: '',
        s: 10,
        p: 1
      }
    };
    this.pageChange = this.pageChange.bind(this);
    this.setFilterParam = this.setFilterParam.bind(this);
    this.advanceReset = this.advanceReset.bind(this);
    this.advanceSubmit = this.advanceSubmit.bind(this);
    this.routeLeaveHook = this.routeLeaveHook.bind(this);
  }

  goView (url) {
    hashHistory.push(url);
  }
    /*筛选重置*/
  advanceReset () {
    
  };
    /* 筛选确认 */
  advanceSubmit (form) {
    let self = this;
    this.setState({
      searchObj: {
        ...this.state.searchObj,
        p: 1
      }
    }, function () {
      self.initData();
    });
  };
    /*筛选*/
  setFilterParam (name, value) {
    if (name === 'orderTime') {
      this.setState({
        searchObj: {
          ...this.state.searchObj,
          startCreatedDate: value.from,
          endCreatedDate: value.end
        }
      })
    } else {
      this.setState({ searchObj: { ...this.state.searchObj, [name]: value } })
    }
  };
    /*翻页*/
  pageChange (page, s) {
    let self = this;
    this.setState({ searchObj: { ...this.state.searchObj, s, p: page } }, function () {
      self.initData();
    });
  }
    /*获取列表数据*/
  initData () {
  }
  //离开当前路由时，更新store
  routeLeaveHook(nextLocation) {
  }

  componentWillMount () {
  }

  componentDidMount () {
    this.initData();
    //设置离开当前路由时的钩子函数
    this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
  }

  render () {let self = this;
    const { opts, key, rows, total, searchObj } = this.state;
    const advanceProps = {
        fileds: [
            {
                name: 'code',
                label: '订单编号',
                text: '输入订单编号',
                type: 'default',
                defaultValue: searchObj.code
            },
            {
                name: 'name1',
                label: '物料编号',
                text: '输入物料编号',
                type: 'default',
                defaultValue: searchObj.name1
            },
            {
                name: 'gatherRealityAddress',
                label: '实际收货地址',
                text: '输入实际收货地址',
                type: 'default',
                defaultValue: searchObj.gatherRealityAddress
            },
            {
                name: 'orderTime',//startCreatedDate, endCreatedDate
                label: '登记日期',
                options: [
                    { text: '开始时间' },
                    { text: '结束时间' },
                ],
                type: 'dateComp',
                defaultValue: {
                    from: searchObj.startCreatedDate || '',
                    end: searchObj.endCreatedDate || ''
                },
            }
        ],
        handle: this.advanceSubmit,
        reset: this.advanceReset,
        fieldHandle: this.setFilterParam
    };
    const tableViewProps = {
      loading: false,//更新表格数据中
      rowKey: 'id',
      pageParam: {
        total,
        current: searchObj.p,//当前页码
        pageSize: searchObj.s,//当前分页数
        onChange: this.pageChange
      },
      columns: [
        {
            title: '订单编号',
            dataIndex: 'code',
            render: (text, record, index) => {
                return <a href={`#/secCusOrder/${record.id}`}>{text}</a>
            }
        }, 
        {
            title: '客户名称',
            dataIndex: 'cusName'
        },
        {
            title: '客户简称',
            dataIndex: 'cusShortname'
        },
        {
            title: '订单日期',
            dataIndex: 'date'
        },
        {
            title: '销售金额',
            dataIndex: 'receivedAmount'
        },
        {
            title: '订单整体折扣(%)',
            dataIndex: 'orderField'
        },
        {
            title: '实收金额',
            dataIndex: 'amount'
        },
        {
            title: '订单状态',
            dataIndex: 'orderStatus',
            /*render: (text, record, index) => {
                if (text === 1) return '待审核';
                if (text === 2) return '待发货';
                if (text === 3) return '待收货';
                if (text === 4) return '已完成';
                if (text === 5) return '已取消';
                if (text === 6) return '暂存';
                if (text === 7) return '已审核';
                return '';
            }*/
        },
        {
            title: '备注',
            dataIndex: 'remark'
        },
        {
            title: '提交人',
            dataIndex: 'operateName'
        }
      ],
      rows
    };
    return <div>
        <DmsTab options={opts} defaultKey={key}>
            <Button icon="plus" onClick={this.goView.bind(this, '/secCusOrder/add/0')}>新增</Button>
        </DmsTab>
      <div className="advanceForm-box">
        <div className="advanceForm-content">
          <AdvanceFormNew {...advanceProps}/>
        </div>
      </div>
      <div className="dms-table-box">
        <TableView {...tableViewProps}/>
      </div>
    </div>
  }
}

export default withRouter(SecondCusOrderList);


// WEBPACK FOOTER //
// ./src/routes/secCusOrder/list.js